module.exports = __webpack_public_path__ + "saira-semibold-webfont.13dd633599288f489448.woff2";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/assets/fonts/saira-semibold-webfont.woff2
// module id = ../../../../../src/assets/fonts/saira-semibold-webfont.woff2
// module chunks = styles